import { useSelector } from 'react-redux';
import { selectCareCoordinators, selectCareCoordinatorsLoading } from './care-coordinator.selectors';

export const useSelectCareCoordinators = () => useSelector(selectCareCoordinators);
export const useSelectCareCoordinatorsLoading = () => useSelector(selectCareCoordinatorsLoading);
